import React from 'react';
import * as PropTypes from 'prop-types';
import { Button, Modal } from 'react-bootstrap';

const CustomModal = ({
  id,
  title,
  buttons,
  backdrop,
  bsSize,
  children,
  closeButton,
  dismiss,
}) => {
  if (buttons.length === 0) {
    closeButton = true;
  }
  return (
    <Modal
      show={true}
      animation={true}
      backdrop={backdrop}
      backdropClassName="backdrop"
      size={bsSize}
      id={id}
      onHide={() => dismiss(id)}
    >
      <Modal.Header closeButton={closeButton}>
        <Modal.Title>{title}</Modal.Title>
      </Modal.Header>
      <Modal.Body>{children}</Modal.Body>
      {buttons.length > 0 && (
        <Modal.Footer>
          {buttons.map((btn) => (
            <Button
              key={btn.label}
              variant={btn.variant || 'default'}
              onClick={() => btn.action(id)}
            >
              {btn.label}
            </Button>
          ))}
        </Modal.Footer>
      )}
    </Modal>
  );
};

CustomModal.propTypes = {
  id: PropTypes.number.isRequired,
  title: PropTypes.string,
  backdrop: PropTypes.bool,
  bsSize: PropTypes.oneOf(['lg', 'large', 'sm', 'small']),
  buttons: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      action: PropTypes.func.isRequired,
      variant: PropTypes.string,
    })
  ),
  closeButton: PropTypes.bool,
  dismiss: PropTypes.func,
};

CustomModal.defaultProps = {
  backdrop: false,
  bsSize: null,
  buttons: [],
  closeButton: false,
};

export default CustomModal;
